import { ENDPOINT } from "../../constants/endpoint.js";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { messageService } from "../../constants";
import { formatNumber } from "@/utils/index";

const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwODM3NTM3LCJleHAiOjI3MjY2ODA3MzY1NTM3LCJqdGkiOiI3Y2E2NzYwNC1lN2UwLTQ0ZWUtYjY1Ny0wM2EzMDkyNWMwMzcifQ.9YLNDUd2DO6qnlnGfyrdzQRGaeFBE2adWcHWaEV-z_0";

const state = {
  loading: false,
  error: {},
  transferData: [],
  oilTransfers: [],
  oilPrice: null,
  tankerOilTransferForPrint: null
};
const getters = {
  getterOilTransferData: (state) => () => {
    return state.oilTransfers
  },
};
const mutations = {
  SET_OIL_TRANSFER: (state, payload) => {
    state.oilTransfers = payload;
  },
  SET_OIL_PRICE: (state, payload) => {
    state.oilPrice = payload;
  },
  SUCCESS_TRANSFER_DATA(state, payload) {
    state.transferData = payload;
  },
  ERROR_TRANSFER_DATA(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING_TRANSFER_DATA(state, payload) {
    state.loading = payload.loading;
  },
  SET_OIL_TRANSFER_NULL(state) {
    state.oilTransfers = [];
  },
  SET_TANKER_OIL_TRANSFER_FOR_PRINT: (state, payload) => {
    state.tankerOilTransferForPrint = payload;
  },
};

const actions = {
  resetOilTransfer: ({ commit }) => {
    commit("SET_OIL_TRANSFER_NULL");
  },
  setOilTransfer: ({ commit }, payload) => {
    commit("SET_OIL_TRANSFER", payload);
  },
  async getOilTransfers(context, payload) {
    const url = ENDPOINT.MP_TRANSFERS;
    console.log('payload >>> ',payload);
    let params
    if (payload) {
      params = {
        'q[transfer_date_gteq]': payload.startDate,
        'q[transfer_date_lteq]': payload.endDate,
        'q[station_id_eq]': payload.station,
        'q[forward_tanker_id_eq]': payload.forwardTanker,
        'q[tanker_id_eq]': payload.tanker,
        'q[vessel_id_eq]': payload.vessel,
        'q[vessel_province_id_eq]': payload.province,
        per_page: 2000
      }
    }
      await axios
      .get(url, {
        params
      })
      .then(async (res) => {
        const data = _.orderBy(res.data, ['start_at'], ['asc']);
        let oilTransferData = [];
        await data.map(async (a) => {
          const dataTransfer = { ...a };
          oilTransferData.push(dataTransfer)
        })
        context.commit("SET_OIL_TRANSFER", oilTransferData);
      })
      .catch((e) => {
      })
      .finally(() => {
      });
  },
  async getForwardTankerOilTransfers(context, payload) {
    const url = ENDPOINT.MP_TRANSFERS;
    // console.log(payload);
    let oilTransferData = [];
    await axios
      .get(url, {
        params: {
          'q[transfer_date_gteq]': payload.startDate,
          'q[transfer_date_lteq]': payload.endDate,
          'q[station_id_eq]': payload.station,
          'q[forward_tanker_id_eq]': payload.forwardTanker,
          'q[tanker_id_eq]': payload.tanker,
          'q[vessel_id_null]': true,
        }
      })
      .then(async (res) => {
        const data = _.orderBy(res.data, ['start_at'], ['asc']);
        context.commit("SET_OIL_TRANSFER", data);
      })
      .catch((e) => {
      })
      .finally(() => {
      });
  },
  async getOilTransfersUnique(context, payload) {
    context.commit("LOADING_TRANSFER_DATA", { loading: true });
    const url = ENDPOINT.MP_TRANSFERS;
    // console.log(payload);
    await axios
      .get(url, {
        params: {
          'q[transfer_date_gteq]': payload.startDate,
          'q[transfer_date_lteq]': payload.endDate,
          'q[station_id_eq]': payload.station,
          'q[forward_tanker_id_eq]': payload.forwardTanker,
          'q[tanker_id_eq]': payload.tanker,
          'q[vessel_id_eq]': payload.vessel,
        }
      })
      .then(async (res) => {
        // const data = res.data;
        // console.log("res.data ", res.data);
        // let oilTransferData = [];
        // await data.map(async (a) => {
        //   const dataTransfer = { ...a };
        //   oilTransferData.push(dataTransfer)
        // })
        const data = _.orderBy(res.data, ['start_at'], ['asc']);
        await context.commit("SET_OIL_TRANSFER", data);
        context.commit("LOADING_TRANSFER_DATA", { loading: false });
      })
      .catch((e) => {
      })
      .finally(() => {
      });
  },
  async getOilPrice(context) {
    context.commit("SET_OIL_PRICE", null);

    // const url = ENDPOINT.GET_OIL_PRICE
    // await axios
    //   .get(url)
    //   .then(async (res) => {
    //     // console.log(res.data);
    //     context.commit("SET_OIL_PRICE", res.data);
    //   })
    //   .catch((e) => {
    //   })
    //   .finally(() => {
    //   });
  },
  setTankerOilTransferForPrint(context , payload){
    context.commit("SET_TANKER_OIL_TRANSFER_FOR_PRINT", payload);
  },
  clearOilTransfers(context){
    context.commit("SET_OIL_TRANSFER", []);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
